import React from "react";

const TOOTSIE_STARTERS = [
  { slot: "QB", name: "P. Manning", pts: "20.40", season: 2004 },
  { slot: "RB", name: "M. Faulk", pts: "17.20", season: 2000 },
  { slot: "RB", name: "L. Tomlinson", pts: "14.30", season: 2006 },
  { slot: "WR", name: "R. Moss", pts: "15.80", season: 2007 },
  { slot: "WR", name: "T. Holt", pts: "13.50", season: 2003 },
  { slot: "TE", name: "T. Gonzalez", pts: "11.40", season: 2004 },
  { slot: "FLEX", name: "D. Sproles", pts: "10.60", season: 2011 },
  { slot: "K", name: "A. Vinatieri", pts: "12.90", season: 2003 },
];

const BREECE_STARTERS = [
  { slot: "QB", name: "A. Rodgers", pts: "20.80", season: 2011 },
  { slot: "RB", name: "J. Charles", pts: "14.60", season: 2013 },
  { slot: "RB", name: "M. Forte", pts: "12.80", season: 2010 },
  { slot: "WR", name: "L. Fitzgerald", pts: "14.20", season: 2008 },
  { slot: "WR", name: "M. Evans", pts: "11.50", season: 2016 },
  { slot: "TE", name: "R. Gronkowski", pts: "12.20", season: 2015 },
  { slot: "FLEX", name: "B. Hall", pts: "11.20", season: 2022 },
  { slot: "K", name: "J. Tucker", pts: "11.40", season: 2016 },
];

function lineupTotal(starters) {
  return starters.reduce((sum, row) => sum + Number(row.pts), 0).toFixed(2);
}

function LineupColumn({ teamLabel, starters, variant }) {
  return (
    <div className={`ffb-landing-lineup-col ffb-landing-lineup-col-${variant}`}>
      <div className="ffb-landing-lineup-header">
        <span className="ffb-landing-lineup-team">{teamLabel}</span>
        <span className="ffb-landing-lineup-total">{lineupTotal(starters)}</span>
      </div>
      <ul className="ffb-landing-lineup-list">
        {starters.map((row) => (
          <li key={`${row.slot}-${row.name}`} className="ffb-landing-lineup-row">
            <span className="ffb-landing-lineup-slot">{row.slot}</span>
            <span className="ffb-landing-lineup-player">{row.name}</span>
            <span className="ffb-landing-lineup-pts">{row.pts}</span>
            <span className="ffb-landing-lineup-season">{row.season}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function LandingHero({ onGetStarted, onLearnMore, onBrowsePublic }) {
  return (
    <section className="ffb-landing-hero" aria-label="Welcome to Fantasy Football Classic">
      <div className="ffb-landing-hero-inner">
        <p className="ffb-landing-eyebrow">2026 inaugural season · Free public leagues</p>
        <h2 className="ffb-landing-headline">
          Draft NFL legends. Scores come from real history.
        </h2>
        <p className="ffb-landing-subhead">
          A full season-long fantasy league — draft, lineups, waivers, and playoffs — powered by
          historical NFL stats from 1999–2025. Not a one-game sim or daily contest.
        </p>

        <ul className="ffb-landing-bullets">
          <li>
            <span className="ffb-landing-bullet-icon" aria-hidden="true">📊</span>
            <span>
              Each <strong>starter gets their own</strong> historical game for that NFL week — drawn
              only from <strong>seasons when that player actually played</strong> (1999–2025).
            </span>
          </li>
          <li>
            <span className="ffb-landing-bullet-icon" aria-hidden="true">⏱️</span>
            <span>
              Scores <strong>reveal at kickoff</strong> — strategy without knowing the exact game in advance.
            </span>
          </li>
          <li>
            <span className="ffb-landing-bullet-icon" aria-hidden="true">🏆</span>
            <span>
              <strong>Full lineups</strong> face off head-to-head each week — 14-week regular season plus playoffs.
            </span>
          </li>
        </ul>

        <div className="ffb-landing-preview" aria-hidden="true">
          <div className="ffb-landing-preview-label">Example — Week 3 head-to-head</div>
          <div className="ffb-landing-matchup">
            <LineupColumn
              teamLabel="Tootsie Sproles"
              starters={TOOTSIE_STARTERS}
              variant="you"
            />
            <span className="ffb-landing-preview-vs">vs</span>
            <LineupColumn
              teamLabel="Breece's Pieces"
              starters={BREECE_STARTERS}
              variant="opp"
            />
          </div>
          <p className="ffb-landing-preview-foot">
            Each starter&apos;s score comes from a different historical NFL game; season shown after reveal.
          </p>
        </div>

        <div className="ffb-landing-cta-row">
          <button type="button" className="ffb-btn ffb-landing-cta-primary" onClick={onGetStarted}>
            Sign up / Log in
          </button>
          <button type="button" className="ffb-btn ffb-landing-cta-secondary" onClick={onLearnMore}>
            How it works
          </button>
        </div>
        <button type="button" className="ffb-landing-browse-link" onClick={onBrowsePublic}>
          Browse open public leagues ↓
        </button>
        <p className="ffb-landing-pricing-hint">
          Public leagues: <strong>free</strong> · Private leagues: commissioner pays one-time $40 inaugural-season platform fee
        </p>
      </div>
    </section>
  );
}
